import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import CardHeader from "@mui/material/CardHeader"
import { useTheme } from "@mui/material/styles"

import Column from "../../../common/components/Column"
import RecruitProfileNestedPanel from "./RecruitProfileNestedPanel"
import {
  RECRUIT_PROFILE_SELF_NESTED_TITLES,
  recruitProfileSectionCardSx,
  recruitProfileSectionHeaderSx,
} from "./recruitProfileSectionStyles"

/**
 * Section card for recruiting campaign profile (edit dialog + read-only view).
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.subheader]
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.useNestedPanel] Wrap body in inner panel (false when children already use nested panels).
 */
export default function RecruitProfileSectionCard({
  title,
  subheader,
  children,
  useNestedPanel,
}) {
  const theme = useTheme()
  const wrapInPanel =
    useNestedPanel ?? !RECRUIT_PROFILE_SELF_NESTED_TITLES.has(title)

  return (
    <Card variant="outlined" sx={recruitProfileSectionCardSx(theme)}>
      <CardHeader
        title={title}
        subheader={subheader}
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 700 }}
        subheaderTypographyProps={{
          variant: "body2",
          color: "text.secondary",
          sx: { mt: subheader ? 0.5 : 0 },
        }}
        sx={recruitProfileSectionHeaderSx(theme)}
      />
      <CardContent
        sx={{
          pt: 1.5,
          px: { xs: 1.5, sm: 2 },
          pb: 2,
          "&:last-child": { pb: 2 },
        }}
      >
        {wrapInPanel ? (
          <RecruitProfileNestedPanel>{children}</RecruitProfileNestedPanel>
        ) : (
          <Column sx={{ gap: 2.5, alignItems: "stretch" }}>{children}</Column>
        )}
      </CardContent>
    </Card>
  )
}
